"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  logos: {
    acceptedFileTypes: ['image/*'],
    title: 'Logos',
    notesPlaceholder: 'Enter Logo notes',
    groupTypePlaceholder: {
      primary: 'Primary Logo',
      secondary: 'Secondary Logo'
    },
    inputButtonPrefix: 'Drop any .jpg .png .gif or',
    previewType: 'IMAGE'
  },
  typefaces: {
    acceptedFileTypes: ['.ttf', '.otf', '.waff', '.eot'],
    title: 'Typography',
    notesPlaceholder: 'Enter Typeface notes',
    groupTypePlaceholder: {
      primary: 'Primary Typeface',
      secondary: 'Secondary Typeface'
    },
    inputButtonPrefix: 'Drop any .otf .ttf .waff, .eot or',
    previewType: 'FONT'
  },
  videoTemplates: {
    acceptedFileTypes: ['video/*'],
    title: 'Video Templates',
    groupTypePlaceholder: {
      primary: 'Primary Template',
      secondary: 'Secondary Template'
    },
    initialGroupTypeNames: ['Lower-Third Title', 'Intro Animation'],
    inputButtonPrefix: 'Drop any video',
    previewType: 'VIDEO'
  },
  styleguides: {
    acceptedFileTypes: ['.pdf', '.doc', '.docx'],
    title: 'Styleguide',
    groupTypePlaceholder: {
      primary: 'Primary Styleguide',
      secondary: 'Secondary Styleguide'
    },
    initialGroupTypeNames: ['Guidelines'],
    inputButtonPrefix: 'Drop any .pdf .doc .docx or',
    previewType: 'DOC',
    isLastStep: true
  }
};
exports.default = _default;